import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'


const NotePage = () => {
  const { isMobile } = useMedia()

  const { meta, note, notes, gender, products } = useConnect({
    meta: 'view.seoPage.meta',
    note: 'view.seoPage.note',
    notes: 'view.seoPage.notes',
    gender: 'view.seoPage.gender',
    products: 'view.seoPage.products',
  })

  const metadata = {
    placement: 'seo page',
  }

  return (
    <Fragment>
      <Helmet
        title={meta.title}
        meta={[
          { name: 'description', content: meta.description },
        ]}
      />
      {
        React.createElement(isMobile ? Mobile : ExceptMobile, {
          gender,
          note,
          notes,
          products,
          productsAtPage: 1000,
          metadata,
        })
      }
    </Fragment>
  )
}


export default NotePage
